import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

const store = (set) => ({
  session: null,
  setSession: (id) => set((state) => {
    state.session = id;
  }),
  responses: {},
  clearResponses: () => set((state) => {
    state.responses = {};
  }),
  setResponse: (id, response) => set((state) => {
    state.responses[id] = response;
  }),
  results: null,
  setResults: (results) => set((state) => {
    state.results = results;
  }),
  screenings: null,
  setScreenings: (screenings) => set((state) => {
    state.screenings = screenings;
  }),
});

const immutableStore = immer(store);
const useStore = create(immutableStore);

export default useStore;
